const headers = {
  name: "Clear Supplier Balance",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by invoice number",
      value: "",
    },
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Suppliers",
        path: "/app/suppliers",
      },
      {
        name: "Clearing Balances",
        path: "",
      },
      {
        name: "Balance Logs",
        path: "/app/suppliers/balance-logs",
      },
    ],
  },
};

export default headers;
